import { UseFormReturn } from 'react-hook-form';

import { FormField, FormItem, FormMessage } from '@@/ui/primitives';
import { Field } from '../../../../schemas/entity';
import { CreateItemPayload } from '../../../../schemas/item';
import { PromptInput } from '../../../shared/field-inputs';

interface PromptFieldRendererProps {
  fieldKey: string;
  field: Field;
  form: UseFormReturn<CreateItemPayload['attributes']>;
  label: string;
  disabled?: boolean;
}

export function PromptFieldRenderer({ fieldKey, field, form, label, disabled = false }: PromptFieldRendererProps) {
  const definition = field.definition;

  if (definition.type !== 'prompt') {
    return null;
  }

  return (
    <FormField
      control={form.control}
      name={fieldKey}
      render={({ field: formField }) => (
        <FormItem>
          <PromptInput
            value={formField.value ?? { content: '', kind: 'SSML' }}
            onChange={formField.onChange}
            label={label}
            fieldKey={fieldKey}
            disabled={disabled}
          />
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
